/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindJobPositionLevelQueryResponse
 */
export interface FindJobPositionLevelQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof FindJobPositionLevelQueryResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FindJobPositionLevelQueryResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FindJobPositionLevelQueryResponse
     */
    description: string;
}

/**
 * Check if a given object implements the FindJobPositionLevelQueryResponse interface.
 */
export function instanceOfFindJobPositionLevelQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function FindJobPositionLevelQueryResponseFromJSON(json: any): FindJobPositionLevelQueryResponse {
    return FindJobPositionLevelQueryResponseFromJSONTyped(json, false);
}

export function FindJobPositionLevelQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindJobPositionLevelQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
    };
}

export function FindJobPositionLevelQueryResponseToJSON(value?: FindJobPositionLevelQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
    };
}

